"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _LifeInsurance = _interopRequireDefault(require("../blocks/LifeInsurance"));
var _DeathDismemberment = _interopRequireDefault(require("../blocks/DeathDismemberment"));
var _DependentLife = _interopRequireDefault(require("../blocks/DependentLife"));
var _STD = _interopRequireDefault(require("../blocks/STD"));
var _LTD = _interopRequireDefault(require("../blocks/LTD"));
var _CriticalIllness = _interopRequireDefault(require("../blocks/CriticalIllness"));
var _Drugs = _interopRequireDefault(require("../blocks/Drugs"));
var _Healthcare = _interopRequireDefault(require("../blocks/Healthcare"));
var _Dental = _interopRequireDefault(require("../blocks/Dental"));
var _SpendingAccounts = _interopRequireDefault(require("../blocks/SpendingAccounts"));
var _EFAP = _interopRequireDefault(require("../blocks/EFAP"));
var _VirtualHealthcare = _interopRequireDefault(require("../blocks/VirtualHealthcare"));
var _FinancialAwareness = _interopRequireDefault(require("../blocks/FinancialAwareness"));
var _Text = _interopRequireDefault(require("../../../components/Text"));
var _OutOfCountry = _interopRequireDefault(require("../blocks/OutOfCountry"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ModularFlexForm = /*#__PURE__*/function (_Component) {
  function ModularFlexForm() {
    (0, _classCallCheck2["default"])(this, ModularFlexForm);
    return _callSuper(this, ModularFlexForm, arguments);
  }
  (0, _inherits2["default"])(ModularFlexForm, _Component);
  return (0, _createClass2["default"])(ModularFlexForm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        blueprint = _this$props.blueprint,
        errors = _this$props.errors,
        isMasterSite = _this$props.isMasterSite,
        saveModularBenefitInitData = _this$props.saveModularBenefitInitData,
        saveModularField = _this$props.saveModularField,
        whitelabel = _this$props.whitelabel,
        setChangesMadeFlag = _this$props.setChangesMadeFlag;
      var styles = {
        tierBlock: {
          // border: "2px solid #F1F1F1",
          borderRadius: "5px",
          padding: "30px",
          marginTop: "10px",
          marginBottom: "10px"
        },
        tireBlockTitle: {
          display: 'flex',
          flex: 1,
          flexDirection: 'row',
          alignItems: 'center'
        },
        tierNumberCircle: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: "30px",
          height: "30px",
          borderRadius: "30px",
          marginRight: "10px"
        }
      };
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        style: _objectSpread({
          backgroundColor: '#FDF6EA',
          border: "2px solid #F9D7A2"
        }, styles.tierBlock)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.tireBlockTitle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: _objectSpread({
          backgroundColor: '#F4AF47'
        }, styles.tierNumberCircle)
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        bold: true,
        medium: true,
        color: "#FFFFFF"
      }, "1")), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        bold: true,
        large: true
      }, "Gold Tier")), /*#__PURE__*/_react["default"].createElement(_Healthcare["default"], {
        type: "modular",
        tier: "gold",
        lightTierColor: "#FFEDCE",
        darkTierColor: "#F4AF47",
        classID: this.props.classID,
        data: blueprint.health.gold.healthcare,
        errors: errors ? errors.health.gold.healthcare : {},
        isMasterSite: isMasterSite,
        saveModularBenefitInitData: saveModularBenefitInitData,
        saveModularField: saveModularField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), /*#__PURE__*/_react["default"].createElement(_Drugs["default"], {
        type: "modular",
        tier: "gold",
        lightTierColor: "#FFEDCE",
        darkTierColor: "#F4AF47",
        classID: this.props.classID,
        data: blueprint.health.gold.drugs,
        errors: errors ? errors.health.gold.drugs : {},
        isMasterSite: isMasterSite,
        saveModularBenefitInitData: saveModularBenefitInitData,
        saveModularField: saveModularField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), /*#__PURE__*/_react["default"].createElement(_Dental["default"], {
        type: "modular",
        tier: "gold",
        lightTierColor: "#FFEDCE",
        darkTierColor: "#F4AF47",
        classID: this.props.classID,
        data: blueprint.dental.gold,
        errors: errors ? errors.dental.gold : {},
        isMasterSite: isMasterSite,
        saveModularBenefitInitData: saveModularBenefitInitData,
        saveModularField: saveModularField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), /*#__PURE__*/_react["default"].createElement(_SpendingAccounts["default"], {
        type: "modular",
        tier: "gold",
        lightTierColor: "#FFEDCE",
        darkTierColor: "#F4AF47",
        classID: this.props.classID,
        data: blueprint.health.gold.spendingAccounts,
        errors: errors ? errors.health.gold.spendingAccounts : {},
        isMasterSite: isMasterSite,
        saveModularBenefitInitData: saveModularBenefitInitData,
        saveModularField: saveModularField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      })), /*#__PURE__*/_react["default"].createElement("div", {
        style: _objectSpread({
          backgroundColor: '#F4F6F8',
          border: "2px solid #C7CCD6"
        }, styles.tierBlock)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.tireBlockTitle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: _objectSpread({
          backgroundColor: '#A0A7B7'
        }, styles.tierNumberCircle)
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        bold: true,
        medium: true,
        color: "#FFFFFF"
      }, "2")), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        bold: true,
        large: true
      }, "Silver Tier")), /*#__PURE__*/_react["default"].createElement(_Healthcare["default"], {
        type: "modular",
        tier: "silver",
        lightTierColor: "#EAEEF2",
        darkTierColor: "#A0A7B7",
        classID: this.props.classID,
        data: blueprint.health.silver.healthcare,
        errors: errors ? errors.health.silver.healthcare : {},
        isMasterSite: isMasterSite,
        saveModularBenefitInitData: saveModularBenefitInitData,
        saveModularField: saveModularField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), /*#__PURE__*/_react["default"].createElement(_Drugs["default"], {
        type: "modular",
        tier: "silver",
        lightTierColor: "#EAEEF2",
        darkTierColor: "#A0A7B7",
        classID: this.props.classID,
        data: blueprint.health.silver.drugs,
        errors: errors ? errors.health.silver.drugs : {},
        isMasterSite: isMasterSite,
        saveModularBenefitInitData: saveModularBenefitInitData,
        saveModularField: saveModularField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), /*#__PURE__*/_react["default"].createElement(_Dental["default"], {
        type: "modular",
        tier: "silver",
        lightTierColor: "#EAEEF2",
        darkTierColor: "#A0A7B7",
        classID: this.props.classID,
        data: blueprint.dental.silver,
        errors: errors ? errors.dental.silver : {},
        isMasterSite: isMasterSite,
        saveModularBenefitInitData: saveModularBenefitInitData,
        saveModularField: saveModularField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), /*#__PURE__*/_react["default"].createElement(_SpendingAccounts["default"], {
        type: "modular",
        tier: "silver",
        lightTierColor: "#EAEEF2",
        darkTierColor: "#A0A7B7",
        classID: this.props.classID,
        data: blueprint.health.silver.spendingAccounts,
        errors: errors ? errors.health.silver.spendingAccounts : {},
        isMasterSite: isMasterSite,
        saveModularBenefitInitData: saveModularBenefitInitData,
        saveModularField: saveModularField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      })), /*#__PURE__*/_react["default"].createElement("div", {
        style: _objectSpread({
          backgroundColor: '#F9EDE5',
          border: "2px solid #EBCDBA"
        }, styles.tierBlock)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.tireBlockTitle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: _objectSpread({
          backgroundColor: '#D08D64'
        }, styles.tierNumberCircle)
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        bold: true,
        medium: true,
        color: "#FFFFFF"
      }, "3")), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        bold: true,
        large: true
      }, "Bronze Tier")), /*#__PURE__*/_react["default"].createElement(_Healthcare["default"], {
        type: "modular",
        tier: "bronze",
        lightTierColor: "#F9EDE5",
        darkTierColor: "#D08D64",
        classID: this.props.classID,
        data: blueprint.health.bronze.healthcare,
        errors: errors ? errors.health.bronze.healthcare : {},
        isMasterSite: isMasterSite,
        saveModularBenefitInitData: saveModularBenefitInitData,
        saveModularField: saveModularField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), /*#__PURE__*/_react["default"].createElement(_Drugs["default"], {
        type: "modular",
        tier: "bronze",
        lightTierColor: "#F9EDE5",
        darkTierColor: "#D08D64",
        classID: this.props.classID,
        data: blueprint.health.bronze.drugs,
        errors: errors ? errors.health.bronze.drugs : {},
        isMasterSite: isMasterSite,
        saveModularBenefitInitData: saveModularBenefitInitData,
        saveModularField: saveModularField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), /*#__PURE__*/_react["default"].createElement(_Dental["default"], {
        type: "modular",
        tier: "bronze",
        lightTierColor: "#F9EDE5",
        darkTierColor: "#D08D64",
        classID: this.props.classID,
        data: blueprint.dental.bronze,
        errors: errors ? errors.dental.bronze : {},
        isMasterSite: isMasterSite,
        saveModularBenefitInitData: saveModularBenefitInitData,
        saveModularField: saveModularField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), /*#__PURE__*/_react["default"].createElement(_SpendingAccounts["default"], {
        type: "modular",
        tier: "bronze",
        lightTierColor: "#F9EDE5",
        darkTierColor: "#D08D64",
        classID: this.props.classID,
        data: blueprint.health.bronze.spendingAccounts,
        errors: errors ? errors.health.bronze.spendingAccounts : {},
        isMasterSite: isMasterSite,
        saveModularBenefitInitData: saveModularBenefitInitData,
        saveModularField: saveModularField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      })), /*#__PURE__*/_react["default"].createElement(_LifeInsurance["default"], {
        type: "modular",
        classID: this.props.classID,
        data: blueprint.lifeInsurance,
        errors: errors ? errors.lifeInsurance : {},
        isMasterSite: isMasterSite,
        saveModularBenefitInitData: saveModularBenefitInitData,
        saveModularField: saveModularField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), /*#__PURE__*/_react["default"].createElement(_DeathDismemberment["default"], {
        type: "modular",
        classID: this.props.classID,
        data: blueprint.deathDismemberment,
        errors: errors ? errors.deathDismemberment : {},
        isMasterSite: isMasterSite,
        saveModularBenefitInitData: saveModularBenefitInitData,
        saveModularField: saveModularField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), /*#__PURE__*/_react["default"].createElement(_DependentLife["default"], {
        type: "modular",
        classID: this.props.classID,
        data: blueprint.dependentLife,
        errors: errors ? errors.dependentLife : {},
        isMasterSite: isMasterSite,
        saveModularBenefitInitData: saveModularBenefitInitData,
        saveModularField: saveModularField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), /*#__PURE__*/_react["default"].createElement(_STD["default"], {
        type: "modular",
        classID: this.props.classID,
        data: blueprint.std,
        errors: errors ? errors.std : {},
        isMasterSite: isMasterSite,
        saveModularBenefitInitData: saveModularBenefitInitData,
        saveModularField: saveModularField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), /*#__PURE__*/_react["default"].createElement(_LTD["default"], {
        type: "modular",
        classID: this.props.classID,
        data: blueprint.ltd,
        errors: errors ? errors.ltd : {},
        isMasterSite: isMasterSite,
        saveModularBenefitInitData: saveModularBenefitInitData,
        saveModularField: saveModularField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), /*#__PURE__*/_react["default"].createElement(_CriticalIllness["default"], {
        type: "modular",
        classID: this.props.classID,
        data: blueprint.criticalIllness,
        errors: errors ? errors.criticalIllness : {},
        isMasterSite: isMasterSite,
        saveModularBenefitInitData: saveModularBenefitInitData,
        saveModularField: saveModularField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), /*#__PURE__*/_react["default"].createElement(_OutOfCountry["default"], {
        type: "modular",
        classID: this.props.classID,
        data: blueprint.outOfCountry || {},
        errors: errors ? errors.outOfCountry : {},
        isMasterSite: isMasterSite,
        saveModularBenefitInitData: saveModularBenefitInitData,
        saveModularField: saveModularField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), /*#__PURE__*/_react["default"].createElement(_EFAP["default"], {
        type: "modular",
        classID: this.props.classID,
        data: blueprint.efap || {},
        errors: errors ? errors.efap : {},
        isMasterSite: isMasterSite,
        saveModularBenefitInitData: saveModularBenefitInitData,
        saveModularField: saveModularField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), /*#__PURE__*/_react["default"].createElement(_VirtualHealthcare["default"], {
        type: "modular",
        classID: this.props.classID,
        data: blueprint.virtualHealthcare || {},
        errors: errors ? errors.virtualHealthcare : {},
        isMasterSite: isMasterSite,
        saveModularBenefitInitData: saveModularBenefitInitData,
        saveModularField: saveModularField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), /*#__PURE__*/_react["default"].createElement(_FinancialAwareness["default"], {
        type: "modular",
        classID: this.props.classID,
        data: blueprint.financialAwareness || {},
        errors: errors ? errors.financialAwareness : {},
        isMasterSite: isMasterSite,
        saveModularBenefitInitData: saveModularBenefitInitData,
        saveModularField: saveModularField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }));
    }
  }]);
}(_react.Component);
var _default = exports["default"] = ModularFlexForm;